// SCSS
import '../../assets/scss/sectionFour.scss';

const SectionFour = ({ register, formData, handleChange }) => {
	return (
		<div className='sectionFour'>
			<div className='imageVideoAd flex-col'>
				<div className='content'>
					<h2>Stillbildeannonse eller animert annonse?</h2>
				</div>
				<div className='flex-row checkboxes'>
					<div className='checkbox-container stillbildeannonse'>
						<input
							type='radio'
							name='adType'
							id='adType-stillbildeannonse'
							value='stillbildeannonse'
							className='checkbox-card-input'
							checked={Boolean(formData.stillbildeannonse)}
							onChange={() => {
								handleChange('stillbildeannonse', true);
								handleChange('animatedAd', false);
							}}
						/>
						<label
							htmlFor='adType-stillbildeannonse'
							className='checkbox-card-label'
						>
							Stillbildeannonse
						</label>
					</div>
					<div className='checkbox-container animatedAd'>
						<input
							type='radio'
							name='adType'
							id='adType-animatedAd'
							value='animatedAd'
							className='checkbox-card-input'
							checked={Boolean(formData.animatedAd)}
							onChange={() => {
								handleChange('animatedAd', true);
								handleChange('stillbildeannonse', false);
							}}
						/>
						<label
							htmlFor='adType-animatedAd'
							className='checkbox-card-label'
						>
							Animert annonse
						</label>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SectionFour;
